import { Link } from "react-router-dom";

import { useSiteConfig } from "../../contexts/SiteConfigContext";
import "./Footer.scss";

const currentYear = new Date().getFullYear();

const Footer = ({ t, copyright: copyrightProp }) => {
  const site = useSiteConfig();

  const gmail = site.gmail || "";
  const twitter = site.twitter || "";
  const facebook = site.facebook || "";
  const instagram = site.instagram || "";
  const phone = site.phoneInfo || "";
  const phone2 = site.phone2Info || "";
  const email = site.emailInfo || "";
  const address = site.addressInfo || "";
  const copyright =
    copyrightProp || site.copyright || `© ${currentYear} PkPlots`;

  return (
    <footer className='site-footer'>
      <div className='site-footer__inner'>
        <div className='site-footer__grid'>
          {/* Brand + tagline */}
          <div className='site-footer__brand'>
            <Link to='/' aria-label='PkPlots home'>
              <img src='assets/img/logo.svg' alt='PkPlots' />
            </Link>
            <p className='site-footer__tagline'>
              An online real estate platform for Pakistan. Find verified
              homes, plots and rentals, or list yours in minutes.
            </p>
            {(twitter || facebook || instagram || gmail) && (
              <div className='site-footer__social'>
                {gmail && (
                  <a
                    className='site-footer__social-link'
                    href={`mailto:${gmail}`}
                    title='Email'
                    aria-label='Email'
                  >
                    <i className='bx bxl-gmail' aria-hidden='true'></i>
                  </a>
                )}
                {twitter && (
                  <a
                    className='site-footer__social-link'
                    href={twitter}
                    target='_blank'
                    rel='nofollow noopener noreferrer'
                    title='Twitter'
                    aria-label='Twitter'
                  >
                    <i className='bx bxl-twitter' aria-hidden='true'></i>
                  </a>
                )}
                {facebook && (
                  <a
                    className='site-footer__social-link'
                    href={facebook}
                    target='_blank'
                    rel='nofollow noopener noreferrer'
                    title='Facebook'
                    aria-label='Facebook'
                  >
                    <i className='bx bxl-facebook' aria-hidden='true'></i>
                  </a>
                )}
                {instagram && (
                  <a
                    className='site-footer__social-link'
                    href={instagram}
                    target='_blank'
                    rel='nofollow noopener noreferrer'
                    title='Instagram'
                    aria-label='Instagram'
                  >
                    <i className='bx bxl-instagram' aria-hidden='true'></i>
                  </a>
                )}
              </div>
            )}
          </div>

          {/* Quick links */}
          <div>
            <h2 className='site-footer__col-title'>{t("footer.get_to")}</h2>
            <ul className='site-footer__list'>
              <li>
                <Link className='site-footer__link' to='/about'>
                  {t("footer.about")}
                </Link>
              </li>
              <li>
                <Link className='site-footer__link' to='/contact'>
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Explore */}
          <div>
            <h2 className='site-footer__col-title'>Explore</h2>
            <ul className='site-footer__list'>
              <li>
                <Link
                  className='site-footer__link'
                  to='/properties/lahore/Sale?page=1'
                >
                  Homes for sale
                </Link>
              </li>
              <li>
                <Link
                  className='site-footer__link'
                  to='/properties/lahore/Rent?page=1'
                >
                  Homes for rent
                </Link>
              </li>
              {/* <li>
                <Link className='site-footer__link' to='/users/signup'>
                  List a property
                </Link>
              </li> */}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h2 className='site-footer__col-title'>
              {t("footer.connect") || "Get in touch"}
            </h2>
            <ul className='site-footer__list'>
              {email && (
                <li className='site-footer__contact-item'>
                  <i className='bx bx-envelope' aria-hidden='true'></i>
                  <a href={`mailto:${email}`}>{email}</a>
                </li>
              )}
              {phone && (
                <li className='site-footer__contact-item'>
                  <i className='bx bx-phone' aria-hidden='true'></i>
                  <a href={`tel:${phone.replace(/[^+\d]/g, "")}`}>{phone}</a>
                </li>
              )}
              {phone2 && (
                <li className='site-footer__contact-item'>
                  <i className='bx bx-phone' aria-hidden='true'></i>
                  <a href={`tel:${phone2.replace(/[^+\d]/g, "")}`}>{phone2}</a>
                </li>
              )}
              {address && (
                <li className='site-footer__contact-item'>
                  <i className='bx bx-map' aria-hidden='true'></i>
                  <span>{address.replace(/^Address:\s*/i, "")}</span>
                </li>
              )}
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className='site-footer__bottom'>
          <span>{copyright}</span>
          <ul className='site-footer__bottom-links'>
            <li>
              <Link to='/privacy'>{t("footer.privacy")}</Link>
            </li>
            <li>
              <Link to='/terms'>{t("footer.terms")}</Link>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
